/**
 * TAB 切换功能模块
 * 功能：实现 TAB 标签页的切换显示
 * 使用：通过 data-id 属性关联 TAB 链接和内容区域
 */
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  /**
   * 初始化 TAB 切换功能
   */
  var tabLinks = document.querySelectorAll('.tab-a');
  
  tabLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var dataId = this.getAttribute('data-id');

      // 移除所有 TAB 内容区域的 active 状态
      document.querySelectorAll('.tab').forEach(function (tab) {
        tab.classList.remove('tab-active');
      });

      // 显示对应的 TAB 内容
      var targetTab = document.querySelector(".tab[data-id='" + dataId + "']");
      if (targetTab) {
        targetTab.classList.add('tab-active');
      }

      // 移除所有 TAB 链接的 active 状态
      tabLinks.forEach(function (link) {
        link.classList.remove('active-a');
      });

      // 为当前点击的链接添加 active 状态
      this.classList.add('active-a');
    });
  });
});

/**
 * Multi-column 响应式功能模块
 * 功能：处理 multi-column 组件的响应式行为和 hover 交互
 * 特性：
 * - 设备检测（移动端/桌面端）
 * - Hover 交互处理
 * - 动态 CSS 类管理
 * - 窗口大小变化监听
 * - DOM 变化监听
 */
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  let resizeTimeout;

  // 设备检测函数
  function isMobileDevice() {
    return window.innerWidth <= 768;
  }

  // 处理multi-column组件的hover交互
  function initMultiColumnHover() {
    const multiColumnItems = document.querySelectorAll('.multi-column__grid-item');

    multiColumnItems.forEach(item => {
      const imageWrapper = item.querySelector('.multi-column__grid-item-image-wrapper');
      const overlayContent = item.querySelector('.overlay-content');
      const enableHoverOverlay = item.querySelector('[data-enable-hover-overlay]')?.getAttribute('data-enable-hover-overlay') === 'true';

      if (imageWrapper && overlayContent && enableHoverOverlay) {
        const isMobile = isMobileDevice();

        if (!isMobile) {
          // 桌面端hover交互
          // 当hover在image-wrapper上时，显示overlay-content
          imageWrapper.addEventListener('mouseenter', function () {
            overlayContent.style.opacity = '1';
            imageWrapper.classList.add('hover-active');
          });

          imageWrapper.addEventListener('mouseleave', function () {
            overlayContent.style.opacity = '0';
            imageWrapper.classList.remove('hover-active');
          });

          // 当hover在overlay-content上时，保持overlay-content显示并显示image-wrapper的::before
          overlayContent.addEventListener('mouseenter', function () {
            overlayContent.style.opacity = '1';
            // 通过添加一个类来触发::before的显示
            imageWrapper.classList.add('hover-active');
          });

          overlayContent.addEventListener('mouseleave', function () {
            overlayContent.style.opacity = '0';
            imageWrapper.classList.remove('hover-active');
          });
        } else {
          // 移动端：文本直接显示在图片下面，不需要hover交互
          // 确保文本内容可见
          overlayContent.style.opacity = '1';
        }
      }
    });
  }

  // 动态设置multi-column文本容器的CSS类
  function updateMultiColumnTextContainers() {
    const textContainers = document.querySelectorAll('.multi-column__grid-item-text-container');
    const isMobile = isMobileDevice();

    textContainers.forEach(container => {
      const enableHoverOverlay = container.getAttribute('data-enable-hover-overlay') === 'true';
      if (enableHoverOverlay) {
        // 移除现有的类
        container.classList.remove('section', 'multi-column-padding-top', 'overlay-content');

        // 移除所有overlay-position类
        const overlayPositionClasses = container.className.match(/overlay-position-\w+/g) || [];
        overlayPositionClasses.forEach(className => {
          container.classList.remove(className);
        });
        // 根据设备类型添加相应的类
        if (isMobile) {
          // 移动端：使用section和multi-column-padding-top类
          container.classList.add('section', 'multi-column-padding-top');
          // 移除overlay相关的属性
          container.removeAttribute('data-overlay');
        } else {
          // 桌面端：使用overlay-content类
          container.classList.add('overlay-content');
          // 添加overlay属性
          container.setAttribute('data-overlay', 'true');

          // 检查是否有位置配置
          const overlayPosition = container.getAttribute('data-overlay-position') || 'center';
          container.classList.add(`overlay-position-${overlayPosition}`);
        }
      }
    });
  }

  // 初始化
  function initMultiColumn() {
    initMultiColumnHover();
    updateMultiColumnTextContainers();
  }

  // 初始化
  initMultiColumn();

  // 监听窗口大小变化（使用防抖）
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initMultiColumn();
    }, 250); // 250ms防抖
  });

  // 监听动态内容变化（如果有AJAX加载的内容）
  const observer = new MutationObserver(function (mutations) {
    let shouldUpdate = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // 检查是否有新的multi-column项目被添加
        const hasNewMultiColumn = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            return node.querySelector('.multi-column__grid-item') ||
              node.classList.contains('multi-column__grid-item');
          }
          return false;
        });

        if (hasNewMultiColumn) {
          shouldUpdate = true;
        }
      }
    });

    if (shouldUpdate) {
      initMultiColumn();
    }
  });

  // 开始观察
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/**
 * Complete the look Section 功能模块
 * 功能：处理产品变体选择、添加到购物车和弹窗功能
 * 特性：
 * - 颜色选择器（swatches）交互
 * - 下拉选择器变更处理
 * - 产品变体匹配和更新
 * - 添加到购物车功能
 * - Modal 弹窗功能
 */
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  // 收集选中选项的辅助函数
  function collectSelectedOptions(modifySection) {
    let selectedOptions = {
      option1: null,
      option2: null,
      option3: null
    };

    // for swatches option
    modifySection.querySelectorAll('.product-custom-swatch .swatch_option').forEach(function (swatchOption) {
      let selectedButton = swatchOption.querySelector('.product__color-swatches button.product__color-swatch.selected');
      let value = selectedButton ? selectedButton.getAttribute('data-option-value') : null;
      let op_id = swatchOption.querySelector('.product__color-swatches--inner select')?.id;

      if (op_id === 'option1') {
        selectedOptions.option1 = value;
      } else if (op_id === 'option2') {
        selectedOptions.option2 = value;
      } else if (op_id === 'option3') {
        selectedOptions.option3 = value;
      }
    });

    // for dropdown option
    modifySection.querySelectorAll('.product-custom-option .product__option').forEach(function (customOption) {
      let selectElement = customOption.querySelector('select');
      let value = selectElement ? selectElement.value : null;
      let op_id = selectElement ? selectElement.id : null;

      if (op_id === 'option1') {
        selectedOptions.option1 = value;
      } else if (op_id === 'option2') {
        selectedOptions.option2 = value;
      } else if (op_id === 'option3') {
        selectedOptions.option3 = value;
      }
    });

    return selectedOptions;
  }

  // 更新产品变体的辅助函数
  function updateVariant(modifySection, selectedOptions) {
    const variantScript = modifySection.querySelector('script[data-variant-json]');

    if (variantScript) {
      const variantData = JSON.parse(variantScript.textContent);
      // Find matching variant
      const matchingVariant = variantData.find(variant =>
        variant.option1 === selectedOptions.option1 &&
        variant.option2 === selectedOptions.option2 &&
        variant.option3 === selectedOptions.option3
      );

      if (matchingVariant) {
        modifySection.querySelector('.product-add-to-cart a').setAttribute('data-id', matchingVariant.id);

        if (matchingVariant.available) {
          modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
          modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
          var avail_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-avail-label');
          modifySection.querySelector('.product-add-to-cart a').textContent = avail_label;
        } else {
          modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
          modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
          var sold_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-sold-label');
          modifySection.querySelector('.product-add-to-cart a').textContent = sold_label;
        }

        if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
          var image_tag = modifySection.querySelector('.product-image img');
          if (image_tag) {
            image_tag.setAttribute('src', matchingVariant.featured_image.src);
          }
        }
      }
    }
  }

  // 初始化颜色选择器
  function initColorSwatches() {
    document.querySelectorAll('.modify-complete-the-look-section .product-custom-swatch .swatch_option .product__color-swatches button.product__color-swatch').forEach(function (button) {
      button.addEventListener('click', function () {
        // Remove 'selected' class from sibling buttons
        this.parentElement.querySelectorAll('button.product__color-swatch').forEach(function (sibling) {
          sibling.classList.remove('selected');
        });

        // Add 'selected' class to the clicked button
        this.classList.add('selected');
        let value = this.getAttribute('data-option-value');
        if (value) {
          const labelWrapper = this.closest('.swatch_option').querySelector('.product__label-wrapper [data-selected-value-for-option]');
          if (labelWrapper) {
            labelWrapper.textContent = value;
          }
        }

        let modifySection = this.closest('.modify-complete-product');
        let selectedOptions = collectSelectedOptions(modifySection);
        updateVariant(modifySection, selectedOptions);
      });
    });
  }

  // 初始化下拉选择器
  function initDropdownSelects() {
    document.querySelectorAll('.modify-complete-the-look-section .product-custom-option').forEach(function (option) {
      option.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('change', function () {
          let value = this.value;
          if (value) {
            const labelWrapper = this.closest('.product__option').querySelector('.product__label-wrapper [data-selected-value-for-option]');
            if (labelWrapper) {
              labelWrapper.textContent = value;
            }
          }

          let modifySection = this.closest('.modify-complete-product');
          let selectedOptions = collectSelectedOptions(modifySection);
          updateVariant(modifySection, selectedOptions);
        });
      });
    });
  }

  // 初始化添加到购物车功能
  function initAddToCart() {
    document.querySelectorAll('.modify-complete-the-look-section .modify-complete-product').forEach(function (product) {
      const addToCartBtn = product.querySelector('.product-add-to-cart a');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          console.log('Add to cart clicked');
          var var_id = this.getAttribute('data-id');
          var arrPdp = [];

          arrPdp.push({ id: var_id, quantity: 1 });
          let formData = { 'items': arrPdp };
          fetch('/cart/add.js', {
            body: JSON.stringify(formData),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
          }).then((response) => {
            return response.json();
          }).then((res) => {
            var event = new CustomEvent('apps:product-added-to-cart');
            document.dispatchEvent(event);

            const c_btn = document.querySelector('a.header__icon-touch[href="/cart"]');
            if (c_btn) {
              c_btn.click();
            }
          });
        });
      }
    });
  }

  // Modal 弹窗功能
  function initModal() {
    const popupTriggers = document.querySelectorAll('.modify-complete-the-look-section [data-popup-trigger]');
    const modal = document.querySelector('[data-modal]');
    const modal_content = document.querySelector('[data-modal] .modal__content');

    if (!modal || !modal_content) return;

    // Helper functions
    function t$2(n, t) {
      return [].slice.call((t || document).querySelectorAll(n));
    }

    function wrapIframes(elements = []) {
      elements.forEach(el => {
        const wrapper = document.createElement("div");
        wrapper.classList.add("rte__iframe");
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        el.src = el.src; // Reload iframe source
      });
    }

    function wrapTables(elements = []) {
      elements.forEach(el => {
        const wrapper = document.createElement("div");
        wrapper.classList.add("rte__table-wrapper");
        wrapper.tabIndex = 0;
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
      });
    }

    // Reusable function to render modal content
    const _renderModalContent = (content) => {
      const clonedContent = content.cloneNode(true);
      modal_content.innerHTML = ""; // Clears previous content in the modal
      modal_content.appendChild(clonedContent);
      wrapIframes(t$2("iframe", modal_content));
      wrapTables(t$2("table", modal_content));
    };

    // Function to open the modal
    const _open = () => {
      modal.classList.add('active');
      document.body.setAttribute("data-fluorescent-overlay-open", "true");

      if (typeof disableBodyScroll !== 'undefined') {
        disableBodyScroll(modal, {
          allowTouchMove: (el) => {
            while (el && el !== document.body) {
              if (el.getAttribute("data-scroll-lock-ignore") !== null) {
                return true;
              }
              el = el.parentNode;
            }
          },
          reserveScrollBarGap: true
        });
      }
    };

    // Loop through each trigger and attach a click event
    popupTriggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const modalContentId = trigger.getAttribute('data-modal-content-id');
        const modalContent = document.querySelector(`#${modalContentId}`);

        if (modalContent) {
          _renderModalContent(modalContent);
          _open();

          // Dispatch custom event (optional)
          document.dispatchEvent(new CustomEvent('modal:open', {
            detail: { modalContent, narrow: false }
          }));
        }
      });
    });
  }

  // 初始化所有功能
  initColorSwatches();
  initDropdownSelects();
  initAddToCart();
  initModal();
});

